if (!customElements.get('product-modal-opener')) {
    class ProductModalOpener extends HTMLElement {
        constructor() {
            super();
            this.type = this.dataset.type;
            this.addEventListener("click", (event) => {
                const button = event.target.closest("[data-media-id]");
                if (!button) return;
                this.handleClick(button);
            });
        }

        handleClick(button) {
            const productMedia = this.closest('main-product')?.querySelector('product-media');
            if (!productMedia) return;

            const mediaId = button.dataset.mediaId;
            const context_key = mediaId;

            const existingModal = productMedia.productModalHTML?.[context_key];

            if (existingModal) {
                document.body.appendChild(existingModal);
                existingModal.setAttribute?.("open", "");

                if (this.type === 'model' && window.ShopifyXR) {
                    window.ShopifyXR.setupXRElements();
                }
                return;
            }

            fetch(this.dataset.url)
                .then(response => response.text())
                .then(text => {
                    const modal = new DOMParser()
                        .parseFromString(text, 'text/html')
                        .querySelector('product-modal');

                    if (!modal) return;
                    modal.setAttribute("open", "");
                    document.body.appendChild(modal);

                    if (!productMedia.productModalHTML) {
                        productMedia.productModalHTML = {};
                    }

                    productMedia.productModalHTML[context_key] = modal;
                    if (this.type === 'model' && window.ShopifyXR) {
                        window.ShopifyXR.setupXRElements();
                    }


                })
                .catch(error => console.log(error));
        }
    }

    customElements.define("product-modal-opener", ProductModalOpener);
}



if (!customElements.get('product-modal')) {
    class ProductModal extends HTMLElement {
        constructor() {
            super(),
                (this.closeBtn = this.querySelector("[data-modal-close]")),
                this.closeBtn && this.closeBtn.addEventListener("click", this.closeMediaPopup.bind(this));
        }
        closeMediaPopup() {
            this.removeAttribute('open');
            setTimeout(
                function () {
                    this.remove();
                }.bind(this),
                500
            );

        }
    }
    customElements.define('product-modal', ProductModal);
}